import { padStart } from 'lodash';
import { PasswordRuleConstant} from '@/common/Constants';

const pad = n => padStart(n, 2, '0');
export const getYMD = (d) => {
  const date = new Date(d);
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

export const validateName = value => /^[-0-9a-zA-Z_\u4e00-\u9fa5]{1,32}$/.test(value);

export const validatePassword = value => PasswordRuleConstant.test(value);

export const validateDescription = value => /^[0-9a-zA-Z_\u4e00-\u9fa5]{1,256}$/.test(value);

export const validateHostname = value => /^((?!(^-)|(-$)|(--+))[0-9A-Za-z\\-]){2,60}$/.test(value);



// WEBPACK FOOTER //
// ./src/common/dataHelper.js